import { locales } from "./../utils";

const useLocale = (namespace) => {
  return (ref) => locales.translate(namespace, ref);
};

export default useLocale;
